// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './main.css'
import dataV from '@jiaminghi/data-view'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './utils/flexible.js'


import * as echarts from 'echarts'

Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

Vue.use(ElementUi)
Vue.use(dataV)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
if (process.env.NODE_ENV === 'development') {
  const { mockXHR } = require('../mock')
  mockXHR()
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js